import { lazy } from 'react';

const Main = lazy(() => import("./Main"));
const Onboarding = lazy(() => import('./Onboarding/Index'));
const Home = lazy(() => import("./Home"));
const Interested = lazy(() => import("./Interested/Index"));
const Profile = lazy(() => import("./Profile/Index"));
const Recieved = lazy(() => import("./Interested/Recieved"));
const Search = lazy(() => import("./Search"));
const Send = lazy(() => import("./Interested/Send"));
const Accepted = lazy(() => import("./Interested/Accepted"));
const Declined = lazy(() => import("./Interested/Declined"));
const Favourite = lazy(() => import("./Favourite"));
const Notifications = lazy(() => import("./Notifications"));
const Subscription = lazy(() => import("./Subscription"));
const CreateHoroscope = lazy(() => import("./CreateHoroscope"));
const SuccessStories = lazy(() => import("./SuccessStories"));
const IgnoredProfiles = lazy(() => import("./IgnoredProfiles"));
const Deactivate = lazy(() => import("./Deactivate"));
const ActivePlan = lazy(() => import("./ActivePlan"));
const ProfileView = lazy(() => import("./ProfileView"));
const TermsConditions = lazy(() => import("./TermsConditions"));
const PrivacyPolicy = lazy(() => import("./PrivacyPolicy"));
const RefundPolicy = lazy(() => import("./RefundPolicy"));
const Login = lazy(() => import('./Login/Index'));
const PaymentHistory = lazy(() => import("./PaymentHistory"));
const PaymentStatus = lazy(() => import("./PaymentStatus"));
const AccountDelete = lazy(() => import("./AccountDelete"));
const Maintenance = lazy(() => import("./Maintenance"));
const ContactUs = lazy(() => import("./ContactUs"));

export {
    Main,
    Onboarding,
    Home,
    Interested,
    Profile,
    Recieved,
    Search,
    Send,
    Accepted,
    Declined,
    Favourite,
    Notifications,
    Subscription,
    CreateHoroscope,
    SuccessStories,
    IgnoredProfiles,
    Deactivate,
    ActivePlan,
    ProfileView,
    TermsConditions,
    PrivacyPolicy,
    RefundPolicy,
    Login,
    PaymentHistory,
    PaymentStatus,
    AccountDelete,
    Maintenance,
    ContactUs
}